import { Base } from "../../framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "../company/companyMenuItem";
import { IInstantMessageChannelEditItem, InstantMessageChannelEditItem } from "./instantMessageChannelEditItem";
import { IInstantMessageChannelEditUserItem, InstantMessageChannelEditUserItem } from "./instantMessageChannelUserEditItem";

export interface IInstantMessageChannelEdit {
    userIsInstantMessageChannelAdmin: boolean;
    instantMessageChannel: IInstantMessageChannelEditItem;
    companies: ICompanyMenuItem[];
    users: IInstantMessageChannelEditUserItem[];
    archivingRemoveDate: number;
}

export class InstantMessageChannelEdit implements IInstantMessageChannelEdit {
    userIsInstantMessageChannelAdmin: boolean;
    instantMessageChannel: InstantMessageChannelEditItem;
    companies: CompanyMenuItem[];
    users: InstantMessageChannelEditUserItem[];
    archivingRemoveDate: number;

    constructor();
    constructor(obj: IInstantMessageChannelEdit);
    constructor(obj?: any) {
        this.userIsInstantMessageChannelAdmin = obj && obj.userIsInstantMessageChannelAdmin || false;
        this.instantMessageChannel = new InstantMessageChannelEditItem(obj ? obj.instantMessageChannel : null);
        this.companies = Base.getTypedArray<CompanyMenuItem>(obj ? obj.companies : null, CompanyMenuItem);
        this.users = Base.getTypedArray<InstantMessageChannelEditUserItem>(obj ? obj.users : null, InstantMessageChannelEditUserItem);
        this.archivingRemoveDate = obj && obj.archivingRemoveDate || 0;
    }
}